<template>
  <!-- PSG解析結果入力 -->
  <div id="PSGAnalysisOrder">
    <div id="container-center">
      <div class="labelTitle lable">PSG解析 結果入力</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text"  v-model="searchConditions.receiptNumber"/></td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client"/></td>
            <th>医療機関</th>
            <td><input type="text" v-model="searchConditions.hospital"/></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
                <option></option>
                <option value="1">フルPSG検査</option>
                <option value="2">フルPSG検査（デモ）</option>
                <option value="3">簡易検査</option>
                <option value="4">簡易検査（デモ）</option>
              </select>
            </td>
          </tr>
          <tr>
            <th>返却希望日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.returnDeadlineStart"/> ～ <input type="date" v-model="searchConditions.returnDeadlineEnd"/></td>
            <th>解析期限</th>
            <td colspan="3"><input type="date" v-model="searchConditions.analysisDeadlineStart"/> ～ <input type="date" v-model="searchConditions.analysisDeadlineEnd"/></td>
          </tr>
          <tr>
            <th>解析方法</th>
            <td colspan="2"><select v-model="searchConditions.analysisMethod">
                <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div
        class="result-area"
        v-if="hasResult"
      >
        <b-table
          id="psgAnalyisisResultTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column
              field="id"
              label="受付番号"
              width="80"
              sortable
              centered
            >
              <router-link :to="{name:'PSGAnalysisOrderDetail', params:{receiptNumber:props.row.receiptNumber, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column
              field="analyisCompDate"
              label="返却希望日"
              width="80"
              sortable
              centered
            >
              {{props.row.returnDeadline }}
            </b-table-column>
            <b-table-column
              field="analyisCompDate"
              label="解析期限"
              width="80"
              sortable
              centered
            >
              {{props.row.analysisDeadline }}
            </b-table-column>
            <b-table-column
              field="urgent"
              label="お急ぎ便"
              width="80"
              sortable
              centered
            >
              <span
                v-if="props.row.urgentConvenience"
                class="urgent"
              />
            </b-table-column>
            <b-table-column
              field="kind"
              label="種別"
              width="100"
              sortable
            >
              {{props.row.kind | kindFilter()}}
            </b-table-column>
            <b-table-column
              field="analysisMethod"
              label="解析方法"
              width="180"
              sortable
            >
              {{props.row.analysisMethod | analysisMethodFilter(analysisMethodList)}}
            </b-table-column>
            <b-table-column
              field="reportFormat"
              label="レポート形式"
              width="230"
              sortable
            >
              {{props.row.reportFormat | reportFormatFilter(reportFormatList)}}
            </b-table-column>
            <b-table-column
              field="client"
              label="依頼元"
              sortable
            >
              {{props.row.client}}
            </b-table-column>
            <b-table-column
              field="client"
              label="医療機関"
              sortable
            >
              {{props.row.hospital}}
            </b-table-column>
            <b-table-column
              field="analyst"
              label="担当者"
              sortable
            >
              {{props.row.analysisStaffName}}
            </b-table-column>
            <b-table-column
              field="hospital"
              label=""
              sortable
              v-show="props.row.fileList.length > 0"
            >
              <a @click="showfileArea(props.row.fileList)">
                <b-icon icon="clipboard-file-outline" /></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <floatingDiv v-if="isDownLoadFileList" @close="closeFileArea" title="" width="450px" height="300px" top="100px" right="100px">
      <downLoadFileList :fileList="fileListStr"/>
    </floatingDiv>
  </div>
</template>

<script>
import floatingDiv from "@/components/mock/common/FloatingDiv";
import DownLoadFileList from "@/components/mock/common/DownLoadFileList";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "PSGAnalysisOrder",
  methods: {
    back: function() {
      //外部ユーザーホーム
      this.$router.push({ path: "/guest/home" });
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      var excuteApi = this.getAnalysisListPOST;
      var successCallBack = this.getAnalysisListPOSTSuccess;
      var errorCallBack = this.getAnalysisListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAnalysisListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.externalAnalysis.getAnalysisListPOST({
        body:obj
      });
    },
    getAnalysisListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getAnalysisListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showfileArea: function(fileList) {
      this.fileListStr = fileList;
      this.isDownLoadFileList = true;

    },
    closeFileArea: function(){
      this.isDownLoadFileList = false;
    }
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var analysisMethodList = this.getChoiceList(choicesType.psgMethod, false);
    analysisMethodList.unshift({})
    var reportFormatList = this.getChoiceList(choicesType.psgReportFormat, true);
    return {
      hasResult: false,
      isPaginated: true,
      searchConditions:{
      receiptNumber:"",
      client:"",
      hospital:"",
      kind:"",
      returnDeadlineStart:"",
      returnDeadlineEnd:"",
      analysisDeadlineStart:"",
      analysisDeadlineEnd:"",
      analysisMethod:""
      },
      takeOverSearchParams,
      data: [],
      fileListStr:"",
      isDownLoadFileList: false,
      analysisMethodList,
      reportFormatList
    };
  },
  filters: {
    analysisMethodFilter(value, analysisMethodList){
      var target = analysisMethodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    },
    reportFormatFilter(value, reportFormatList){
      var target = reportFormatList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    },
    kindFilter(val){
      switch(val){
        case "1": return "フルPSG検査"
        case "2": return "フルPSG検査（デモ）"
        case "3": return "簡易検査"
        case "4": return "簡易検査（デモ）"
      }
    },
  },
  components: {
    floatingDiv: floatingDiv,
    downLoadFileList:DownLoadFileList
  },
  mounted: function() {
    // 機種マスタ取得
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/PSGAnalysisOrder.vue